export interface Feature {
  icon: string;
  title: string;
  description: string;
}

export const FEATURES: Feature[] = [
  {
    icon: "⚡",
    title: "Lightning Fast",
    description: "Built with Vite for instant hot module replacement and optimized production builds",
  },
  {
    icon: "🎨",
    title: "Modern UI",
    description: "Beautiful, responsive components built with Tailwind CSS and Shadcn UI",
  },
  {
    icon: "🔒",
    title: "Secure by Default",
    description: "JWT authentication, bcrypt password hashing, and secure session management",
  },
  {
    icon: "📱",
    title: "Responsive Design",
    description: "Works perfectly on desktop, tablet, and mobile devices",
  },
  {
    icon: "🚀",
    title: "Production Ready",
    description: "Docker deployment, database migrations, and comprehensive documentation",
  },
  {
    icon: "🔢",
    title: "Smart Numbering",
    description: "Intelligent number schemas with 11 placeholders and 5 reset strategies",
  },
  {
    icon: "📄",
    title: "Invoice Management",
    description: "Create, edit, and export professional invoices with customizable templates",
  },
  {
    icon: "👥",
    title: "Customer Database",
    description: "Comprehensive customer management with automatic number generation",
  },
  {
    icon: "🏢",
    title: "Company Settings",
    description: "Manage company details, logo, tax settings, and payment terms",
  },
  {
    icon: "🌍",
    title: "Multi-Language",
    description: "Built-in support for German and English with i18next integration",
  },
  {
    icon: "🔄",
    title: "Real-time Updates",
    description: "TanStack Query for efficient data fetching and automatic cache management",
  },
  {
    icon: "🎯",
    title: "Type Safe",
    description: "Full TypeScript support with Zod validation for runtime type safety",
  },
];
